"use client";

import Image from "next/image";
import { QrCodePopover } from "./QrCodePopover";
import { BrandIcon, type BrandIconName } from "@app-foundation/icons";

const accounts: { name: BrandIconName; label: string; image: string }[] = [
  { name: "wechat-official", label: "微信公众号", image: "/images/social/wechat-official-36f7251c.jpg" },
  { name: "douyin", label: "抖音", image: "/images/social/douyin.jpg" },
  { name: "xiaohongshu", label: "小红书", image: "/images/social/xiaohongshu.jpg" },
];

function AccountCode({ name, label, image }: typeof accounts[number]) {
  if (name === "wechat-official") return <Image src={image} alt="Mirafans 镜界微信公众号二维码" width={258} height={258} unoptimized className="h-auto w-full rounded-xl bg-white" />;
  const crop = name === "douyin" ? { width: 1125, x: 195, y: 235, size: 735 } : { width: 912, x: 590, y: 1365, size: 250 };
  return <div className="relative aspect-square w-full overflow-hidden rounded-xl bg-white">
    <Image src={image} alt={`Mirafans 镜界${label}账号二维码`} width={crop.width} height={name === "douyin" ? 1680 : 1686} unoptimized
      className="absolute h-auto max-w-none" style={{ width: `${crop.width / crop.size * 100}%`, left: `${-crop.x / crop.size * 100}%`, top: `${-crop.y / crop.size * 100}%` }} />
  </div>;
}

function SocialAccount({ name, label, image }: typeof accounts[number]) {
  return <QrCodePopover label={label} align="left"
    className="flex h-11 w-11 items-center justify-center rounded-lg text-[var(--color-muted)] hover:text-[var(--color-paper)] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--color-accent)]"
    trigger={name === "xiaohongshu" ? <span className="flex h-[18px] w-[18px] items-center justify-center rounded-[3px] bg-current"><BrandIcon name={name} size={13} color="var(--color-surface)" /></span> : <BrandIcon name={name} size={18} monochrome />}>
    <AccountCode name={name} label={label} image={image} />
  </QrCodePopover>;
}

export function SocialAccounts() {
  return <div aria-label="关注 Mirafans" className="-ml-[13px] flex items-center gap-1">{accounts.map(account => <SocialAccount key={account.name} {...account} />)}</div>;
}
